import React from 'react';

const Telegram = (props) => (
  <span {...props}>
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM13.0512 17.8972L12.7716 22.0925C13.1811 22.0925 13.3708 21.9041 13.6005 21.676L15.5879 19.7618L19.7225 22.7967C20.4815 23.2133 21.0308 22.9951 21.2205 22.0925L23.937 9.38758C24.2166 8.27676 23.5175 7.77094 22.7885 8.09824L6.83937 14.2077C5.7508 14.6441 5.76078 15.2491 6.63963 15.4971L10.7343 16.7864L20.2019 10.8455C20.6513 10.5777 21.0607 10.7265 20.7212 11.034L13.0512 17.8972Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export default Telegram;
